import { idGenerator } from '@/services'

export interface SynergridConnectionState {
  requestId: string
}

export const InitialState: SynergridConnectionState = {
  requestId: idGenerator.getNewWebReference()
}
